
export const transFromToSelect = (label, value) => {
    return {
        value,
        label
    }
}

export const selectOptions = (value, data) => {
   return data.find((d) => {
       return d.value === value
   })
}